import type { RagSettings } from '@callhub/shared';

export const DEFAULT_RAG_SETTINGS: RagSettings = {
  enabled: true,
  manualOnly: false,
  topK: 8,
  maxSuggestions: 3,
  minConfidence: 0.35,
  maxContextChars: 6000,
  embeddingModel: '@cf/baai/bge-base-en-v1.5',
  generationModel: '@cf/meta/llama-3.1-8b-instruct',
  promptTemplate:
    'You are an assistant drafting concise customer-facing communication. Use retrieved evidence. Return JSON only.',
};

function clamp(value: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, value));
}

function normalizeNumber(
  value: number,
  fallback: number,
  min: number,
  max: number,
  round: boolean,
): number {
  if (!Number.isFinite(value)) return fallback;
  const bounded = clamp(value, min, max);
  return round ? Math.round(bounded) : bounded;
}

function normalizeModelName(value: string, fallback: string): string {
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : fallback;
}

export function normalizeRagSettingsForSave(raw: RagSettings): RagSettings {
  return {
    enabled: raw.enabled,
    manualOnly: raw.manualOnly,
    topK: normalizeNumber(raw.topK, DEFAULT_RAG_SETTINGS.topK, 1, 20, true),
    maxSuggestions: normalizeNumber(
      raw.maxSuggestions,
      DEFAULT_RAG_SETTINGS.maxSuggestions,
      1,
      6,
      true,
    ),
    minConfidence: normalizeNumber(
      raw.minConfidence,
      DEFAULT_RAG_SETTINGS.minConfidence,
      0,
      1,
      false,
    ),
    maxContextChars: normalizeNumber(
      raw.maxContextChars,
      DEFAULT_RAG_SETTINGS.maxContextChars,
      800,
      20_000,
      true,
    ),
    embeddingModel: normalizeModelName(raw.embeddingModel, DEFAULT_RAG_SETTINGS.embeddingModel),
    generationModel: normalizeModelName(raw.generationModel, DEFAULT_RAG_SETTINGS.generationModel),
    promptTemplate: normalizeModelName(raw.promptTemplate, DEFAULT_RAG_SETTINGS.promptTemplate),
  };
}
